import BranchOrderParcelPicker from 'components/pages/dashboard/parcelOrderForBranch/components copy/orderParcelPicker/BranchOrderParcelPicker';
import { packagingCreate } from 'global/Models/packagingModel';
import { FC, useCallback, useState } from 'react';
import { GoPackage } from 'react-icons/go';

interface IOrderParcelBox {
  setPackage: (_pack?: packagingCreate) => void;
  packaging?: packagingCreate;
}

const BranchOrderAddParcelBox: FC<IOrderParcelBox> = ({ setPackage, packaging }) => {
  //states
  const [showModal, setShowModal] = useState<boolean>(false);

  //function
  const toggleModal = useCallback(() => setShowModal((prevState) => !prevState), []);

  console.log('showModal', showModal);

  return (
    <div className={`${packaging ? 'h-full' : ''}`}>
      <div className='h-full transition-shadow  lg:max-w-[380px] px-6 w-full duration-300 border rounded-lg shadow-none bg-t-bg-color hover:shadow-lg border-t-border-color-base '>
        {!packaging && (
          <span className='flex items-center justify-center w-full h-full gap-1 p-2 cursor-pointer ' onClick={toggleModal}>
            <GoPackage />+ افزودن بسته
          </span>
        )}
      </div>
      <BranchOrderParcelPicker visible={showModal} close={toggleModal} setPackage={setPackage} />
    </div>
  );
};

export default BranchOrderAddParcelBox;
